{{#each uvmAnalysisImpHandles}}
`uvm_analysis_imp_decl(_{{ klass.typeSuffix }})
{{/each}}
